import { Link } from "react-router-dom";

const related = [
  {
    title: "Soft Beige Living Room",
    category: "Living Room",
    path: "/living-room/soft-beige",
    image: "https://public.readdy.ai/ai/img_res/4549e1cadd941d63810ca25471b2b4aa.jpg",
  },
  {
    title: "Best Beige Sofas",
    category: "Product Guide",
    path: "/cozy-corners/best-beige-sofas",
    image: "https://readdy.ai/api/search-image?query=beige%20linen%20sofa%20warm%20living%20room%20afternoon%20sunlight%20natural%20oak%20wood%20floor%20cream%20cushions%20calm%20elegant%20editorial%20interior%20photography&width=800&height=520&seq=san_related2&orientation=landscape",
  },
  {
    title: "Neutral Rugs",
    category: "Product Guide",
    path: "/products/neutral-rugs",
    image: "https://readdy.ai/api/search-image?query=neutral%20area%20rug%20warm%20ivory%20oat%20living%20room%20natural%20light%20calm%20editorial%20interior%20photography%20soft%20texture%20layered%20neutral%20palette&width=800&height=520&seq=san_related3&orientation=landscape",
  },
];

export default function SANRelated() {
  return (
    <section className="py-24 bg-[#FAF7F0]">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        <p
          className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Keep Reading
        </p>
        <h2
          className="text-[#2C2825] text-3xl md:text-4xl mb-12"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
        >
          Related Articles
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {related.map((item) => (
            <Link
              key={item.title}
              to={item.path}
              className="group block cursor-pointer"
            >
              <div className="w-full aspect-[3/2] rounded-xl overflow-hidden mb-5 bg-[#EDE6DA]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <p
                className="text-[#B5A898] text-[10px] tracking-[0.3em] uppercase mb-2"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {item.category}
              </p>
              <h3
                className="text-[#2C2825] text-xl group-hover:text-[#6B5E53] transition-colors"
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
              >
                {item.title}
              </h3>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
